export const FAQ_URL =
  "https://roadroamer.notion.site/Road-Roamer-FAQ-338de055122e4e2081ee14aafd1e0105";
